import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getWages(params: any): AxiosPromise {
    return EndPointService.get('/salaries', { params });
}

function getWage(id: number | string): AxiosPromise {
    return EndPointService.get(`/salaries/${id}`);
}

function deleteWage(id: number | string): AxiosPromise {
    return EndPointService.delete(`/salaries/${id}`);
}

function createWage(payload: any): AxiosPromise {
    return EndPointService.post('/salaries', payload);
}

function updateWage(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/salaries/${id}`, { ...payload });
}

export default {
    getWages,
    getWage,
    deleteWage,
    createWage,
    updateWage,
};
